// extracted by mini-css-extract-plugin
export default {"headingContainer":"styles_headingContainer__sRWTC","formContainer":"styles_formContainer__0G5k7","form":"styles_form__RFChI"};